import React from 'react';
import { Grid, Box, Container, useMediaQuery, useTheme } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setTab } from '../../reducers/UiReducer';
import SearchEngneBus from './SearchEngneBus';
import SearchEngineHotel from './SearchEngineHotel';
import SearchEngineHolidays from './SearchEngineHolidays';
import SearchEngineFlight from './SearchEngineFlight';
import SearchEngineFD from './SearchEngineFD';

const SlideCard = ({ img }) => {
	const dispatch = useDispatch();
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down('sm'));
	const { tab, topTab } = useSelector((state) => state.ui);
	return (
		<Grid container>
			<Grid
				item
				xs={12}
				sm={12}
				md={12}
				lg={12}
				style={{
					height: matches ? '28vh' : '70vh',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
					backgroundColor: 'yellow',
					backgroundImage: `url(${img})`,
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
					backgroundPosition: 'center center',
				}}>
				<Container>
					{topTab === 'flight' ? (
						<Box style={{ display: 'flex', alignItems: 'center', padding: 4 }}>
							<Box
								onClick={() => dispatch(setTab('oneway'))}
								style={{
									padding: 10,
									borderBottom: tab === 'oneway' ? '4px solid #EC5B24' : '',
									cursor: 'pointer',
									borderRadius: 6,
								}}>
								<span style={{ fontWeight: 'bold' }}>Oneway</span>
							</Box>
							<Box
								onClick={() => dispatch(setTab('roundway'))}
								ml={2}
								style={{
									padding: 10,
									borderBottom: tab === 'roundway' ? '4px solid #EC5B24' : '',
									cursor: 'pointer',
									borderRadius: 6,
								}}>
								<span style={{ fontWeight: 'bold' }}>Roundway</span>
							</Box>
						</Box>
					) : (
						''
					)}
					<Box style={{ background: 'white', padding: 24, borderRadius: 5 }}>
						{topTab === 'flight' ? (
							<SearchEngineFlight />
						) : topTab === 'bus' ? (
							<SearchEngneBus />
						) : topTab === 'hotel' ? (
							<SearchEngineHotel />
						) : topTab === 'holiday' ? (
							<SearchEngineHolidays />
						) : (
							<SearchEngineFD />
						)}
					</Box>
				</Container>
			</Grid>
		</Grid>
	);
};
export default SlideCard;
